import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { autop } from '@wordpress/autop';

import { Container } from '@components';
import { getLanguageId } from '@helpers/language';
import PageContext from '@contexts/PageContext';
import { checkEnabled } from '@components/OptionalFeature';
import styles from './PostSummary.module.scss';

const PostSummary = ({ data, componentIsAvailable }) => {
  const pageData = useContext(PageContext);
  const router = useRouter();
  const { locale } = router;
  const {
    Subject,
    ShortDescription,
    PostTextBody,
    Link: buttonLink,
    ButtonText
  } = pageData.PostText.find(({ LanguageId }) => parseInt(LanguageId) === getLanguageId(locale));

  const SubjectEnabled = checkEnabled(data?.DisplayOptions,'Subject');
  const ButtonTextEnabled = checkEnabled(data?.DisplayOptions,'ButtonText');
  const ShortDescriptionEnabled = checkEnabled(data?.DisplayOptions,'ShortDescription');
  const PostTextBodyEnabled = checkEnabled(data?.DisplayOptions,'PostTextBody');

  return (
    componentIsAvailable && (
      <section className={styles.Section}>
        <Container className={styles.Container}>
          <div className={styles.SummaryContent}>
            {SubjectEnabled && <h2 className={styles.Title}>{Subject}</h2>}

            {ShortDescriptionEnabled && (
              <div
                dangerouslySetInnerHTML={{
                  __html: autop(ShortDescription)
                }}
              />
            )}
            {PostTextBodyEnabled && (
              <div
                dangerouslySetInnerHTML={{
                  __html: autop(PostTextBody)
                }}
              />
            )}
            {ButtonTextEnabled && (
              <Link href={buttonLink} prefetch={false}>
                <a className={styles.More}>
                  {ButtonText}
                  <FontAwesomeIcon icon={faChevronRight} />
                </a>
              </Link>
            )}
          </div>
        </Container>
      </section>
    )
  );
};

export default PostSummary;
